import React, { useState, useEffect, FC } from "react";
import { Card, Button } from "reactstrap";
import { TableColumnsType, DatePicker } from "antd";
import {
  Icon,
} from "../../components/Component";
import { useNavigate } from "react-router";
import InventoryAside from "./InventoryAside";
import dayjs from "dayjs";
import usersApis from "../../api/master/users";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";

const MaterialIssue: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [siteOptions, setSiteOptions] = useState<any[]>([]);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  // Fetch sites on component mount
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const data = await usersApis.getCurrentUser();
        if (data) {
          let sitesOptions = data?.siteAccessibility?.map((item: any) => ({
            label: item.siteName,
            value: item.siteID.toString(),
          }));
          setSiteOptions(sitesOptions || []);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSites();
  }, []);

  useEffect(() => {
    viewChange();
    // fetchAllInvoices();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const [columns, setColumns] = useState<TableColumnsType<any>>([
    // {
    //   title: "Order #",
    //   key: "orderId",
    //   dataIndex: "orderId",
    //   width: 220,
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: 200,
    // },
    // {
    //   title: "#",
    //   key: "paginationId",
    //   dataIndex: "paginationId",
    //   width: 200,
    //   sorter: true,
    // },
    {
      title: "#",
      key: "#",
      width: 50,
      render: (text, record, index) => index + 1,
      sorter: true,
    },
    {
      title: "Material Issue Number",
      dataIndex: "issueNumber",
      key: "issueNumber",
      width: 200,
      fixed: "left",
      render: (text) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Site Name",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Creation Date",
      key: "createdAt",
      dataIndex: "createdAt",
      width: 200,
      render: (text, record) => (
        <span>{dayjs(text).format("DD-MMM-YYYY")}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "issueStatus",
      key: "issueStatus",
      width: 200,
    },
    {
      title: "Action",
      key: "operation",
      width: 150,
      render: (text, record: any, index) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              navigate(
                `/view-material-issue-details/${record.materialIssueId}`
              );
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ]);

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="MaterialIssueList"
        title="Material Issue"
        columns={columns}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
              }`}
          >
            <InventoryAside updateSm={setSm} sm={sm} />
          </div>
        }
        selectFilters={[
          {
            title: "Site",
            placeholder: "Select Site",
            options: siteOptions,
            selectionMode: "multiple",
          },
        ]}
        extra={{
          tableScrollX: 1100,
          dateRange: true,
          excelExport: false,
          dataFilterTootip: "Filtering based on creation date",
        }}
      />
    </>
  );
};

export default MaterialIssue;
